import $ from "jquery";
const ApiExplorerClientException = require('./api.explorer.exception').ApiExplorerClientException;

/**
 * JSON-RPC Client
 * 
 * @param Object options
 */

export class ApiExplorerClient {

	/**
	 * Default options
	 */
    options = {
        'onerror': function () {},
        'onsuccess': function () {},
        'url': '',
        'headers': {}
    };

    current = 1;
    onerror = null;
    onsuccess = null;
    onstart = null;
    lastRequest = null;
    lastResponse = null;
    successLastRequest = true;


    constructor(options) {
        this.setOptions(options);
        this.init();
    };
    /**
     * Init client
     */
    init () {
        this.onerror = this.getParam('onerror', function () {});
        this.onsuccess = this.getParam('onsuccess', function () {});
        this.onsuccessresult = this.getParam('onsuccessresult', function () {});
        
        this.initMethods();
    };

    /**
     * Init API methods by url
     */
    initMethods() {
        var instance = this;
        // get all methods
    	$.ajax({
    		'url': this.getParam('url', ''),
            'async': false,
            'success': function (data) {
                if (data.methods) {
                	// create method
                	$.each(data.methods, function(methodName, methodParams) {
                        instance[methodName]  = function () {
                	    	var params = [];
                            for(var i = 0; i < arguments.length; i++){
                                params.push(arguments[i]);
                            }
                            var id = (instance.current++);
                            var callback = params[params.length - 1];
                            var request = {jsonrpc: '2.0', method: methodName, params: params, id: id};
                            
                            var async = false;
                            if ($.type(callback) === 'function') {
                            	async = true;
                            }
                            
                            var res = null;
                            // API request
                            instance.lastRequest = JSON.stringify(request);
                            $.ajax({
                            	'url': instance.getParam('url'),
                                'contentType': 'application/json',
                                'type': methodParams.transport,
                                'processData': false,
                                'dataType': 'json',
                                'cache': false,
                                'data': JSON.stringify(request),
                                'headers': instance.getParam('headers'),
                                'async': async,
                                'success': function (result) {
                                	instance.lastResponse = JSON.stringify(result);
                                	if (instance.onsuccessresult) {
                                    	instance.onsuccessresult(result);
                                	}
                                    if ($.type(result.error) === 'object') {
                                    	instance.successLastRequest = false;
                                    	
                                        res = new ApiExplorerClientException(result.error.code, result.error.message);
                                        instance.onerror(res);
                                    } else {
                                    	instance.successLastRequest = true;
                                    	
                                        res = result.result;
                                        if ($.type(callback) === 'function') {
                                    	    callback(res);
                                        }
                                    }
                                    instance.onsuccess(res, id, methodName);
                                }
                	        });
                            if (!async) {
                            	return res;
                            }
                	    };

                	});
                } else {
                    throw Exception("Methods could not be found");
                }
            }
        });
    };
	
    /**
     * Set client options
     *
     * @param options
     */
    setOptions(options) {
        this.options = $.extend({}, this.options, options);
    };

    /**
     * Get client param, if param is not available in this.options return defaultValue
     * 
     * @param key
     * @param defaultValue
     * @return mixed
     */
    getParam(key, defaultValue) {
        if ($.type(this.options[key]) !== 'undefined') {
            return this.options[key];
        }
        return defaultValue;
    };
    
    getLastRequest() {
    	return this.lastRequest;
    };
    
    getLastResponse() {
    	return this.lastResponse;
    };
    
    isSuccessLastRequest() {
    	return this.successLastRequest;
    };
    
}